export const SET_LOCALE = 'SET_LOCALE';

const setLocale = ({ commit }, payload) => {
    commit(SET_LOCALE, payload);
};

export default {
    setLocale,
};
